import FILE_DISPLAY_NAMES from '../constants/file-display-names';
export const getFileDisplayNames = (mimeType, defaultText = 'MISC. FILE') => {
    return Object.prototype.hasOwnProperty.call(FILE_DISPLAY_NAMES, mimeType)
        ? FILE_DISPLAY_NAMES[mimeType].toUpperCase()
        : defaultText;
};
